// extracted by mini-css-extract-plugin
export default {"root":"InlineFlagCell_root__r8Tqy","text":"InlineFlagCell_text__6X8RU"};